export const qmEntityType = {
  ACCOUNT: { key: 'ACCOUNT', label: 'Account' },
  ORGANIZATION: { key: 'ORGANIZATION', label: 'Organization' },
  CLEAN_ROOM: { key: 'CLEAN_ROOM', label: 'Clean Room' },
};
